import { Icons } from '@Assets/SvgIcons';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import React, { useState } from 'react';
import '../Payment.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserDealspaceList } from '@Store/feature/dealspaceSlice';
import moment from 'moment';
import { useAppSelector } from '@Store/hooks';
import { RouteEnums } from '@Helper/Enums';

type IProps = {
  isUserImo: boolean;
};

function FreeTrialButton({ isUserImo }: IProps) {
  let navigate = useNavigate();
  const userDealspaceList = useAppSelector(getUserDealspaceList);
  const { id } = useParams();
  const [freeTrialModalVisible, setFreeTrialModalVisible] =
    useState<boolean>(false);

  const onClose = () => {
    setFreeTrialModalVisible(false);
  };

  const goPaymentAccount = () => {
    navigate(RouteEnums.PaymentPlan, { state: { dealspaceId: id } });
  };

  return (
    <React.Fragment>
      <button className="free-trial-button" onClick={() => goPaymentAccount()}>
        <Icons.TrialPlanIcon />
        <span style={{ marginLeft: 5 }}>Free Trial</span>
      </button>

      <Dialog
        open={freeTrialModalVisible}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="WorkstreamsCard-func-dialog free-dialog"
      >
        <div className="dialog-header">
          <div className="dialog-title ftm-title">You are on a free trial</div>
          <button className="dialog-close-button" onClick={onClose}>
            <Icons.Cancel color="#000000" />
          </button>
        </div>
        <div className="dialog-content" style={{ flex: 1 }}>
          <div className="free-about">
            <div className="free-title-1">Trial ends on:</div>
            <div className="free-date">
              {moment(
                userDealspaceList?.find(i => i.id === (id ?? ''))?.trialEndDate
              ).format('ll')}
            </div>
            <div className="free-date-desc">
              {moment(
                userDealspaceList?.find(i => i.id === (id ?? ''))
                  ?.trialEndDate ?? ''
              ).diff(moment(), 'days')}{' '}
              days to go
            </div>
          </div>
          <div
            className="free-about-dashed"
            style={{
              marginTop: '26px',
              marginBottom: '26px',
            }}
          >
            You are currently on a trial for Mergeflo. You have full access to
            all features until the date posted above.
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}

export default FreeTrialButton;
